/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import { agentConnectorsGetAgentConnector } from "../../funcs/agentConnectorsGetAgentConnector.js";
import * as operations from "../../models/operations/index.js";
import { formatResult, ToolDefinition } from "../tools.js";

const args = {
  request: operations.GetAgentConnectorRequest$inboundSchema,
};

export const tool$agentConnectorsGetAgentConnector: ToolDefinition<
  typeof args
> = {
  name: "agent-connectors-get-agent-connector",
  description: `Retrieve a connector

Retrieves connector configuration and status without exposing credentials.`,
  args,
  tool: async (client, args, ctx) => {
    const [result, apiCall] = await agentConnectorsGetAgentConnector(
      client,
      args.request,
      { fetchOptions: { signal: ctx.signal } },
    ).$inspect();

    if (!result.ok) {
      return {
        content: [{ type: "text", text: result.error.message }],
        isError: true,
      };
    }

    const value = result.value;

    return formatResult(value, apiCall);
  },
};
